module.exports = __webpack_public_path__ + "img/devil.2b39e171.png";